export default "__VITE_ASSET__mT2DTsHb__"